module.exports = {
	"description": "Icons use graphical symbols to represent an object or concept in your UI.\nThey can be used to aid comprehension of core actions in your app, and to provide feedback for user input.\n\nMineral UI provides a large number of bundled Icon components as well\nas a generic Icon component to which you can provide your own SVG.",
	"displayName": "Icon",
	"methods": [],
	"props": {
		"size": {
			"flowType": {
				"name": "union",
				"raw": "'small' | 'medium' | 'large' | string",
				"elements": [
					{
						"name": "literal",
						"value": "'small'"
					},
					{
						"name": "literal",
						"value": "'medium'"
					},
					{
						"name": "literal",
						"value": "'large'"
					},
					{
						"name": "string"
					}
				]
			},
			"required": false,
			"description": "Available sizes, including custom - e.g. '5em' or '20px'",
			"defaultValue": {
				"value": "'medium'",
				"computed": false
			}
		},
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "SVG content, required for the generic Icon component"
		},
		"color": {
			"flowType": {
				"name": "string"
			},
			"required": false,
			"description": "Fill color, defaults to theme.color_gray_60"
		},
		"rtl": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Flip the Icon horizontally when used with RTL languages"
		},
		"title": {
			"flowType": {
				"name": "string"
			},
			"required": false,
			"description": "Alternative text"
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Icon/Icon.js
// module id = 1650
// module chunks = 0